const state = {
  loadedPages: new Set(),
  nextPage: 1,
  prevPage: 0,
};

const getPageSections = () => {
  const controls = document.querySelector('.load-more-pagination');
  const grid = document.querySelector('#product-grid');
  const loadMoreButton = document.querySelector('.load-more__next');
  const loadPrevButton = document.querySelector('.load-more__prev');

  return {
    controls,
    grid,
    loadMoreButton,
    loadPrevButton,
  }
};

const getURLParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentPage = parseInt(urlParams.get('page')) || 1;
  const currentUrl = new URL(window.location.href);

  return {
    currentPage,
    currentUrl,
    urlParams,
  }
}

const updateURLHash = (searchParams) => {
  history.pushState(
    { searchParams },
    '',
    `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`
  );
};

const updateIndicator = (indicator) => {
  const total = parseInt(indicator.dataset.total);
  const perPage = parseInt(indicator.dataset.perPage);
  const loadedProducts = perPage * (state.nextPage - 1);
  const currentCount = loadedProducts >= total ? total : loadedProducts;

  indicator.textContent = `${currentCount} of ${total} products`;
};

const updateControls = () => {
  const { controls, loadPrevButton, loadMoreButton } = getPageSections();

  if (!controls) {
    return;
  }


  const indicator = document.querySelector('.load-more-indicator');
  const totalPages = parseInt(controls.dataset.totalPages);
  const grid = document.querySelector('#product-grid');

  if (grid) {
    grid.parentNode.appendChild(controls);
  }

  if (loadMoreButton) {
    loadMoreButton.style.display = state.nextPage <= totalPages ? 'inline-block' : 'none';
  }

  if (loadPrevButton) {
    loadPrevButton.style.display = state.prevPage >= 1 ? 'inline-block' : 'none';
  }

  if (indicator) {
    updateIndicator(indicator)
  }
};

const resetPaginationState = () => {
  const { currentPage } = getURLParams();

  state.loadedPages = new Set([currentPage]);
  state.nextPage = currentPage + 1;
  state.prevPage = currentPage - 1;

  updateControls();
};

const loadPage = async (targetPage, insertPosition) => {
  const { controls, grid, loadMoreButton, loadPrevButton } = getPageSections();

  if (!controls && !grid) {
    return;
  }

  const totalPages = parseInt(controls.dataset.totalPages);
  const sectionId = controls.dataset.sectionId;

  if (targetPage < 1) {
    return;
  }

  if (targetPage > totalPages) {
    return;
  }

  if (state.loadedPages.has(targetPage)) {
    return;
  }

  const { currentUrl, urlParams } = getURLParams();

  currentUrl.searchParams.set('page', targetPage);
  currentUrl.searchParams.set('sections', sectionId);

  urlParams.forEach((value, key) => {
    if (key === 'page') {
      return
    }

    currentUrl.searchParams.set(key, value);
  });

  try {
    loadMoreButton?.setAttribute('disabled', 'disabled');
    loadPrevButton?.setAttribute('disabled', 'disabled');
    const response = await fetch(currentUrl.toString());
    const data = await response.json();

    const parser = new DOMParser();
    const html = parser.parseFromString(data[sectionId], 'text/html');
    const newGrid = html.querySelector('#product-grid');

    if (!newGrid) {
      return;
    }

    grid.insertAdjacentHTML(insertPosition, newGrid.innerHTML);

    state.loadedPages.add(targetPage);

    if (insertPosition === 'beforeend') {
      state.nextPage++;
      const newParams = new URLSearchParams(urlParams);
      newParams.set('page', targetPage);
      updateURLHash(newParams.toString());
    }

    if (insertPosition === 'afterbegin') {
      state.prevPage--;
    }

    updateControls();

  } catch (error) {
    console.error(error);
  } finally {
    loadMoreButton?.removeAttribute('disabled');
    loadPrevButton?.removeAttribute('disabled');
  }
};

document.addEventListener('click',async (event) => {
  const loadMoreButton = event.target.closest('.load-more__next');
  const loadPrevButton = event.target.closest('.load-more__prev');

  if (loadMoreButton) {
    event.preventDefault();
    await loadPage(state.nextPage, 'beforeend');
  }

  if (loadPrevButton) {
    event.preventDefault();
    await loadPage(state.prevPage, 'afterbegin');
  }
});

document.addEventListener('DOMContentLoaded', resetPaginationState);